import React from 'react';
import Login from '../components/Login';

const UserLogin: React.FC = () => {
  return (
    <div>
        <Login />
    </div>
  );
};

export default UserLogin;